import { Breadcrumb, Button, Col, ConfigProvider, Flex, Input, Row, Space, Tabs } from "antd"
import { useForm } from "antd/es/form/Form"
import TabPane from "antd/es/tabs/TabPane"
import { MainLayout } from "components/layouts"
import { useTranslation } from "react-i18next"
import { ReactComponent as HistoryIcon } from "../../../assets/icon/historyIcon.svg"
import { PAYMENT_STEP } from "../schemas/PaymentShemas"

const PaymentMainLayout = ({
    getModal = () => { },
    getEmploymentIncomeDeductionTypeModal = () => { },
    onPageByStepChange = () => { },
    getPageByGroup = () => { }
}) => {
    const { t, i18n } = useTranslation()
    const form = useForm(null);

    const { Search } = Input


    return <ConfigProvider theme={{
        components: {
            Tabs: {
                fontSize: "16px",
                borderRadius: "40",
                itemColor: "#404040",
                cardBg: '#CCCCCC',
                cardPadding: '12px',
                colorBorder: '#CCCCCC'
            },
            Tag: {
                borderRadius: "20px"
            }
        }
    }}>
        {getModal}
        {getEmploymentIncomeDeductionTypeModal("income")}
        <MainLayout>
            <Space direction='vertical' size={24} style={{ width: "100%" }}>
                <Row justify="space-between" align="middle">
                    <Col span={21}>
                        <Flex vertical>
                            <Breadcrumb items={[
                                { title: t("home.header"), href: "/" },
                                { title: t("payroll.header"), href: "/payroll" },
                                { title: t("payroll.onGoing"), href: "/payroll" },
                                { title: t("payment_period.payday_period") },
                            ]} />
                            <h2>{t("payment_period.payday_period")}</h2>
                            <Tabs
                                onChange={onPageByStepChange}
                                tabBarStyle={{ justifyContent: 'space-between' }}
                            >
                                {PAYMENT_STEP.map(tab => (
                                    <TabPane
                                        key={tab.key}
                                        tab={i18n.language === 'en' ? tab.nameEn : tab.name}
                                    />
                                ))}
                            </Tabs>
                        </Flex>
                    </Col>
                    <Col span={3} style={{ textAlign: "right" }}>
                        <Button style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px" }}>
                            <Flex align="center" justify="center" gap={8}>
                                <HistoryIcon />
                                <span style={{ color: "#344054" }}>{t("becash.label.history")}</span>
                            </Flex>
                        </Button>
                    </Col>
                </Row>
                {/* <Row justify="center">
                    <div style={{ width: "60%" }}>
                        <PaymentStepComponent step={payrollPeriod?.step ? payrollPeriod?.step : 0} dataSource={modifiedPaymentStep} />
                    </div>
                </Row> */}
                {getPageByGroup()}



            </Space>
        </MainLayout>

    </ConfigProvider >
}

export default PaymentMainLayout